export default {
  methods: {
    /**
     * Send Event from Analytics Defitions
     * @typedef {{ title: string, href?: string, to?: string }} NavigationItem
     * @typedef {{ analytics: ?{ event: string, args?: (item: NavigationItem) => any } }} AnalyticsDefs
     * @param {NavigationItem & AnalyticsDefs} item
     */
    sendEventFromAnalyticsDefs(item) {
      // Check if item sends analytics
      if (!item.analytics) return
      const args = [
        item.analytics.event,
        item.analytics.args && item.analytics.args(item),
      ]

      this.$analytics.sendEvent(...args.filter((arg) => !!arg))
    },
  },
}
